import React from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import avtar from "../../../MobileScreens/assets/images/Profile-Picture.jpg";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import { blue } from '@mui/material/colors';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function MobileSpecificServiceProvider() {
    const navigate = useNavigate();
  return (
    <>
    <div>
      <div className="drawerFixedPatch"></div>
      <div className='topSpace'></div>
      <div className="drawerWithTop">
        <ArrowBackIcon
          className="backArrowMobil"
          onClick={() => navigate("/MobileServiceProvider")}
        />
        <h1>Specific Service Provider</h1>
      </div>
      <div className='SpecificSpMainDiv'>
      <div className='SearchSortDivTab'>
          <input type='text' placeholder='Search' />
          <SortOutlinedIcon sx={{fontSize:30, color: blue[800]}} />
      </div>
      <div className="famDetailsListInrMob">
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro" onClick={()=> navigate('/MobileServiceProviderDetails')}>
            <div className="ImageViewRound">
            <img src={avtar} className="useImage" alt='altimg'/>
            </div>
            <div className="detailsDiMob">
              <div className="mobWithIco">
                <CheckCircleIcon />
                <h1>User Name</h1>
              </div>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
        </div>
        <div className='dividerCommon' />
        <div className='famDetailsListTo'>
        <div className='pollsTitlDescView margineTop10'>
          <p className='pollsDescripTxt'>Houses Working</p>
          <p className='pollsTitleTxt'>WingA-502, WingB-104</p>
        </div>
        <div className='AddToHouseBtnView' onClick={()=>navigate('/MobileServiceProviderDetails')}>
          <p className='AddServiceProviderTxt'>Add to Household</p>
        </div>
        </div>
      </div>
      </div>
    </div>
    </>
  )
}

export default MobileSpecificServiceProvider